module.exports = __webpack_public_path__ + "img/objects-align-bottom.e60522e1.svg";